import { Button, Drawer } from 'antd';
import HistoryPredictions from 'components/HistoryPredictions';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const navItems = [
  {
    key: 'prediction',
    label: 'Dự Đoán',
    icon: '⚽',
    href: '/',
    isExternal: false
  },
  {
    key: 'schedule',
    label: 'Lịch Thi Đấu',
    icon: '🏆'
  },
  {
    key: 'rule',
    label: 'Thể Lệ',
    icon: '🧾',
    href: '/rule',
    isExternal: false
  },
  {
    key: 'result',
    label: 'Kết Quả Dự Đoán',
    icon: '🎁'
  }
];

const HeaderMenu = ({ onScheduleClick, onRuleClick }) => {
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const location = useLocation();
  const navigate = useNavigate();
  const activeNav = location.pathname;
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.C168
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  const handleScheduleClick = () => {
    if (typeof onScheduleClick === 'function') {
      onScheduleClick();
      return;
    }
    window.open('https://ls47.live/', '_blank', 'noopener,noreferrer');
  };

  const handleRuleClick = () => {
    if (typeof onRuleClick === 'function') {
      onRuleClick();
      return;
    }
    navigate('/rule');
  };

  return (
    <div className="w-full">
      <div className="w-full">
        <div className="relative mt-3 md:mt-6 w-full max-w-[1000px] mx-auto px-[8px] md:px-[12px]">
          <div className="h-[64px] md:h-[76px] rounded-xl border border-[#D9E7FF] bg-[#F0F6FF] px-3 md:px-4 lg:px-5 flex items-center justify-between shadow-[0_0.9px_0.09px_rgba(55,110,252,0.25),0_3.6px_6.95px_rgba(102,139,235,0.13),inset_0_-0.9px_4.96px_rgba(13,153,255,0.2),inset_0_1.8px_2.44px_#FFFFFF]">
            {/* Mobile Drawer */}
            <Drawer
              placement="left"
              onClose={() => setIsShowMenu(false)}
              open={isShowMenu}
              closeIcon={null}
              width={260}
              bodyStyle={{ padding: 0, position: 'relative' }}
              style={{
                overflow: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)'
              }}
              className="drawer-hide-scrollbar"
            >
              <style>
                {`
                .drawer-hide-scrollbar {
                  scrollbar-width: none !important;
                  -ms-overflow-style: none !important;
                }
                .drawer-hide-scrollbar::-webkit-scrollbar {
                  display: none !important;
                  width: 0 !important;
                  background: transparent !important;
                }
              `}
              </style>
              <div className="flex items-center justify-center w-full py-5 border-b">
                <Link to="/" onClick={() => setIsModalHistory(false)}>
                  <img
                    src="/assets/images/header/logo.png"
                    alt="Logo"
                    className="h-[44px] w-auto object-contain mx-auto"
                  />
                </Link>
              </div>
              <button
                onClick={() => setIsShowMenu(false)}
                className="absolute top-3 right-3 z-10 text-gray hover:text-gray-400 transition-colors"
                aria-label="Đóng menu"
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: 32,
                  lineHeight: 1,
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
              <div
                className="flex flex-col h-full"
                style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)' }}
              >
                <Link
                  to={settings.link_home}
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-2 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors"
                >
                  Trang chủ
                </Link>
                <Link
                  to="/"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-2 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors"
                >
                  Dự đoán
                </Link>
                <button
                  type="button"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                    handleRuleClick();
                  }}
                  className="flex items-center px-2 py-4 border-0 outline-none appearance-none shadow-none hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors bg-transparent text-left"
                  style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}
                >
                  Thể lệ
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsShowMenu(false);
                    handleScheduleClick();
                  }}
                  className="flex w-full items-center px-2 py-4 border-0 outline-none appearance-none shadow-none hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors bg-transparent text-left"
                >
                  Lịch thi đấu
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsShowMenu(false);
                    setIsModalHistory(true);
                  }}
                  className="flex w-full items-center px-2 py-4 border-0 outline-none appearance-none shadow-none hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors bg-transparent text-left"
                >
                  Kết quả dự đoán
                </button>
                {/* <Link
                to="/prize-structure"
                onClick={() => {
                  setIsModalHistory(false);
                  setIsShowMenu(false);
                }}
                className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
              >
                Kết quả
              </Link> */}
                {/* <Button
                  type="text"
                  className="flex items-center justify-start px-2 py-8 font-bold text-xl w-full text-left text-[#0053DF] transition-colors group"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsModalHistory(true);
                  }}
                  style={{ color: '#0053DF', background: 'transparent', border: 'none' }}
                >
                  <span className="group-hover:text-yellow-300 group-hover:bg-blue-800 w-full block transition-colors">
                    Lịch sử
                  </span>
                </Button> */}
                <Link
                  to={settings.link_login}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-2 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                >
                  Đăng nhập
                </Link>
                <Link
                  to={settings.link_register}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-2 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#0053DF] transition-colors"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                >
                  Đăng ký
                </Link>
              </div>
            </Drawer>

            <div className="flex items-center gap-2 shrink-0">
              <Link
                to="/"
                onClick={() => {
                  setIsModalHistory(false);
                  setIsShowMenu(false);
                }}
                className="hidden md:flex shrink-0"
              >
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="h-[40px] lg:h-[44px] w-auto object-contain"
                />
              </Link>
              {/* Mobile: Menu button */}
              <Button
                type="link"
                onClick={() => setIsShowMenu(true)}
                className="md:hidden p-0 min-w-0"
              >
                <img
                  src="/assets/images/header/menu.png"
                  alt="Menu"
                  className="h-auto w-[28px] object-contain"
                  style={{
                    filter:
                      'brightness(0) saturate(100%) invert(18%) sepia(98%) saturate(4209%) hue-rotate(215deg) brightness(96%) contrast(101%)'
                  }}
                />
              </Button>
              <Link
                to="/"
                onClick={() => {
                  setIsModalHistory(false);
                  setIsShowMenu(false);
                }}
                className="md:hidden shrink-0"
              >
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="h-[36px] mt-2 w-auto object-contain"
                />
              </Link>
            </div>

            <div className="hidden md:flex flex-1 min-w-0 items-center justify-center px-2">
              <div className="flex items-center gap-1 lg:gap-1.5">
                {navItems.map((item) => {
                  const isActive = Boolean(item.href && activeNav === item.href);
                  const itemClass = isActive
                    ? 'bg-[#0053DF] text-white shadow-[0_3px_10px_rgba(0,83,223,0.35)]'
                    : 'bg-transparent text-[#72767E] hover:bg-white/70';

                  if (item.key === 'schedule') {
                    return (
                      <button
                        key={item.key}
                        type="button"
                        onClick={handleScheduleClick}
                        className={`h-[40px] rounded-[10px] px-2 lg:px-3 border-0 inline-flex items-center gap-1 text-[14px] font-semibold transition-colors ${itemClass}`}
                      >
                        <span aria-hidden>{item.icon}</span>
                        <span>{item.label}</span>
                      </button>
                    );
                  }

                  if (item.key === 'rule') {
                    return (
                      <button
                        key={item.key}
                        type="button"
                        onClick={handleRuleClick}
                        className={`h-[40px] rounded-[10px] px-3 lg:px-4 border-0 inline-flex items-center gap-2 text-[15px] font-semibold transition-colors ${itemClass}`}
                      >
                        <span aria-hidden>{item.icon}</span>
                        <span>{item.label}</span>
                      </button>
                    );
                  }

                  if (item.key === 'result') {
                    return (
                      <button
                        key={item.key}
                        type="button"
                        onClick={() => setIsModalHistory(true)}
                        className={`h-[40px] rounded-[10px] px-3 lg:px-4 border-0 inline-flex items-center gap-2 text-[15px] font-semibold transition-colors ${itemClass}`}
                      >
                        <span aria-hidden>{item.icon}</span>
                        <span>{item.label}</span>
                      </button>
                    );
                  }

                  return (
                    <Link
                      key={item.key}
                      to={item.href}
                      className={`h-[40px] rounded-[10px] px-3 lg:px-4 inline-flex items-center gap-2 text-[15px] font-semibold no-underline transition-colors ${itemClass}`}
                      onClick={() => setIsModalHistory(false)}
                    >
                      <span aria-hidden>{item.icon}</span>
                      <span>{item.label}</span>
                    </Link>
                  );
                })}
              </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              <a
                href={settings.link_login}
                target="_blank"
                rel="noopener noreferrer"
                className="h-[36px] min-w-[120px] px-3 rounded-full border-2 border-[#0053DF] bg-white text-[#0053DF] font-bold text-[13px] tracking-[0.02em] uppercase inline-flex items-center justify-center no-underline hover:bg-[#F2F7FF]"
              >
                Đăng Nhập
              </a>
              <a
                href={settings.link_register}
                target="_blank"
                rel="noopener noreferrer"
                className="hidden md:flex h-[36px] min-w-[120px] px-3 rounded-full border-0 bg-[#0053DF] text-white font-bold text-[13px] tracking-[0.02em] uppercase inline-flex items-center justify-center no-underline hover:brightness-110"
              >
                Đăng Ký
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[1000px] relative -mt-6 lg:-mt-20 mx-auto h-auto flex justify-center items-center pointer-events-none">
        <img
          src="/assets/images/header/bannerpc.png"
          alt=""
          className="w-[68%] h-auto object-contain hidden md:flex pointer-events-none"
        />
        <div className="w-[90%] h-auto flex-col flex justify-center items-center md:hidden">
          {/* <img
            src="/assets/images/header/title.png"
            alt=""
            className="w-full h-auto object-contain md:hidden flex"
          /> */}
          <img
            src="/assets/images/header/bannermb.png"
            alt=""
            className="w-full h-auto object-contain md:hidden flex pointer-events-none"
          />
        </div>
        {/* <div className="absolute top-2/3 left-1/2 -translate-x-1/2 -translate-y-1/2 -mt-2 md:mt-2">
          <CountDownFinal />
        </div> */}
      </div>

      {/* <div className="flex flex-row justify-center items-center w-full gap-2 sm:gap-4 lg:gap-6 md:py-3 py-0 px-2 -mt-2 md:mt-0">
        {navItems.map((item) => {
          const isActive = activeNav === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`text-center min-w-[68px] text-[10px] md:text-[14px] font-semibold flex items-center justify-center transition-colors duration-200 w-auto h-[50px] bg-transparent`}
            >
              <img
                src={isActive ? item.iconActive : item.icon}
                alt="Lịch sử"
                className="w-full h-full object-contain"
              />
            </Link>
          );
        })}
        <button
          onClick={() => setIsModalHistory(true)}
          className="text-center text-[12px] md:text-[14px] font-semibold text-white hover:text-white/80 transition-colors duration-200 cursor-pointer border-none flex items-center justify-center w-auto h-[50px] bg-transparent"
        >
          <img
            src="/assets/images/header/btn_lichsu.png"
            alt="Lịch sử"
            className="w-full h-full object-contain"
          />
        </button>
      </div> */}
      {/* </div> */}

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default HeaderMenu;
